const RegistrationRequestedEvent = "RegistrationRequested";
const RegistrationCompletedEvent = "RegistrationCompleted";
const ProjectPageVisitedEvent = "ProjectPageVisited"

export const registrationRequested = (user) => {
  if (typeof dataLayer === 'undefined') return
  dataLayer.push({
    event: RegistrationRequestedEvent,
  })

}

export const registrationCompleted = (user) => {
  // Event snippet for Registrierung (Sign-Up für Investment) conversion page
  if (typeof gtag === 'undefined') return
  gtag('event', 'conversion', {
    'send_to': 'AW-432749837/V2TeCI69z_kBEI36rM4B',
    event: RegistrationCompletedEvent
  })
  if (typeof dataLayer === 'undefined') return
  dataLayer.push({
    event: RegistrationCompletedEvent
  })
}

export const projectPage = (page) => {
  // Event snippet for Seitenaufruf Projektpage conversion page
  if (typeof gtag === 'undefined') return
  gtag('event', 'conversion', {
    'send_to': 'AW-432749837/SrpgCLWEz_kBEI36rM4B',
    event: ProjectPageVisitedEvent,
  })
  if (typeof dataLayer === 'undefined') return
  dataLayer.push({
    event: ProjectPageVisitedEvent,
  })
}
